import React, { Dispatch, useCallback, useEffect } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { AddProject, ReStartProject, SaveProject } from "../api/postapi";
import { GetDetailProject } from "../api/projectapi";
import { ProjectAction } from "../interface/interface";
import { FixProjectDataChange, MeetupBasicDataChange } from "../lib/lib";
import { LoadingChange, ToastChange } from "../reducers/config";
import { LeaderInter, LeaderReset } from "../reducers/data";

type Props = {
  type: "prjt" | "mtup";
  id: string | undefined;
  prjtType: string | undefined;
  dispatch: Dispatch<ProjectAction>;
  leaderInfo: LeaderInter;
};
type PostProject_Return = [
  (data: any) => void,
  (
    type: string,
    payload: string | number | boolean,
    index: number | undefined
  ) => void,
  (data: any) => void
];

const UsePostProject = ({
  type,
  id,
  prjtType,
  dispatch,
  leaderInfo,
}: Props): PostProject_Return => {
  const rdpatch = useDispatch();
  const navigate = useNavigate();
  const PostProject = useCallback(
    (data: any) => {
      rdpatch(LoadingChange(true));
      AddProject(
        id
          ? Object.assign(
              {
                prjt_id: id,
              },
              data
            )
          : data
      )
        .then(({ state, msg }) => {
          if (state) {
            if (prjtType !== "prjt_sts_rcrt_paus") {
              navigate(`/${type}/start`);
              rdpatch(LoadingChange(false));
            } else {
              if (id) {
                ReStartProject(id).then((result) => {
                  if (result.state) {
                    navigate(`/${type}/start`);
                  }
                  rdpatch(LoadingChange(false));
                });
              } else {
                rdpatch(LoadingChange(false));
              }
            }
          } else {
            rdpatch(LoadingChange(false));
            rdpatch(ToastChange({ active: true, content: msg }));
          }
        })
        .catch((err) => {
          rdpatch(LoadingChange(false));
        });
    },
    [navigate, prjtType, id, rdpatch]
  );
  const ProjectSave = useCallback(
    (data: any) => {
      rdpatch(LoadingChange(true));
      SaveProject(
        id
          ? Object.assign(
              {
                prjt_id: id,
              },
              data
            )
          : data
      )
        .then(({ state, msg }) => {
          if (state) {
            navigate(`/${type}/extra`);
            rdpatch(LoadingChange(false));
          } else {
            rdpatch(LoadingChange(false));
            rdpatch(ToastChange({ active: true, content: msg }));
          }
        })
        .catch((err) => {
          rdpatch(LoadingChange(false));
        });
    },
    [navigate, prjtType, id, rdpatch]
  );
  const UpdateCommon = useCallback(
    (
      type: string,
      payload: string | number | boolean,
      index: number | undefined
    ) => {
      dispatch({
        type,
        payload,
        index,
      });
    },
    [dispatch]
  );

  const ProjectDetail = useCallback(
    (id: string) => {
      GetDetailProject(id).then(({ state, data }) => {
        if (state) {
          dispatch({
            type: "dispatch/all",
            payload:
              type === "prjt"
                ? FixProjectDataChange(data)
                : MeetupBasicDataChange(data),
            index: undefined,
          });
        }
      });
    },
    [dispatch, type]
  );

  useEffect(() => {
    const data = sessionStorage.getItem("write");

    if (data) {
      dispatch({
        type: "dispatch/all",
        payload: JSON.parse(data),
        index: undefined,
      });
    } else if (id) {
      ProjectDetail(id);
    }
    return () => {};
  }, [id, ProjectDetail, dispatch, type]);
  useEffect(() => {
    return () => {
      sessionStorage.removeItem("write");
      rdpatch(LeaderReset());
    };
  }, []);

  useEffect(() => {
    const { name, id } = leaderInfo;
    dispatch({
      type: "leader/info",
      payload: {
        name,
        id,
      },
      index: undefined,
    });
    return () => {};
  }, [leaderInfo]);
  return [PostProject, UpdateCommon, ProjectSave];
};

export default UsePostProject;
